/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HobbiesResponseDto
 */
export interface HobbiesResponseDto {
    /**
     * Patient identity
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    patientId: string;
    /**
     * QuestionnaireResponse identifier
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    questionnaireResponseId?: string;
    /**
     * Indicates whether the patient enjoys hobbies
     * @type {boolean}
     * @memberof HobbiesResponseDto
     */
    hasHobbies?: boolean;
    /**
     * Types of hobbies the patient enjoys
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    hobbyTypes?: string;
    /**
     * How often hobbies fit into the patient's schedule
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    hobbyScheduleFrequency?: string;
    /**
     * Hobbies the patient wants to pick up, if any
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    hobbiesToPickUp?: string;
    /**
     * Indicates whether the patient wants to learn new skills
     * @type {boolean}
     * @memberof HobbiesResponseDto
     */
    wantsToLearnNewSkills?: boolean;
    /**
     * Skills the patient wants to learn
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    skillsToLearn?: string;
    /**
     * Time the patient wants to spend learning new skills
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    skillLearningTimeCommitment?: string;
    /**
     * Target daily time for hobbies and skills, in minutes
     * @type {number}
     * @memberof HobbiesResponseDto
     */
    targetDailyTimeMinutes?: number;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof HobbiesResponseDto
     */
    lastUpdated: string;
}

/**
 * Check if a given object implements the HobbiesResponseDto interface.
 */
export function instanceOfHobbiesResponseDto(value: object): value is HobbiesResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function HobbiesResponseDtoFromJSON(json: any): HobbiesResponseDto {
    return HobbiesResponseDtoFromJSONTyped(json, false);
}

export function HobbiesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HobbiesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'questionnaireResponseId': json['questionnaireResponseId'] == null ? undefined : json['questionnaireResponseId'],
        'hasHobbies': json['hasHobbies'] == null ? undefined : json['hasHobbies'],
        'hobbyTypes': json['hobbyTypes'] == null ? undefined : json['hobbyTypes'],
        'hobbyScheduleFrequency': json['hobbyScheduleFrequency'] == null ? undefined : json['hobbyScheduleFrequency'],
        'hobbiesToPickUp': json['hobbiesToPickUp'] == null ? undefined : json['hobbiesToPickUp'],
        'wantsToLearnNewSkills': json['wantsToLearnNewSkills'] == null ? undefined : json['wantsToLearnNewSkills'],
        'skillsToLearn': json['skillsToLearn'] == null ? undefined : json['skillsToLearn'],
        'skillLearningTimeCommitment': json['skillLearningTimeCommitment'] == null ? undefined : json['skillLearningTimeCommitment'],
        'targetDailyTimeMinutes': json['targetDailyTimeMinutes'] == null ? undefined : json['targetDailyTimeMinutes'],
        'lastUpdated': json['lastUpdated'],
    };
}

export function HobbiesResponseDtoToJSON(json: any): HobbiesResponseDto {
    return HobbiesResponseDtoToJSONTyped(json, false);
}

export function HobbiesResponseDtoToJSONTyped(value?: HobbiesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'questionnaireResponseId': value['questionnaireResponseId'],
        'hasHobbies': value['hasHobbies'],
        'hobbyTypes': value['hobbyTypes'],
        'hobbyScheduleFrequency': value['hobbyScheduleFrequency'],
        'hobbiesToPickUp': value['hobbiesToPickUp'],
        'wantsToLearnNewSkills': value['wantsToLearnNewSkills'],
        'skillsToLearn': value['skillsToLearn'],
        'skillLearningTimeCommitment': value['skillLearningTimeCommitment'],
        'targetDailyTimeMinutes': value['targetDailyTimeMinutes'],
        'lastUpdated': value['lastUpdated'],
    };
}

